import styled from "styled-components";

export const SectionTitle = styled.p`
  color: #000000;
  font-size: 20px;
  margin: 2rem 1rem 0.5rem;
  line-height: 20px;
  letter-spacing: 0.15px;
  font-weight: 600;
  text-align: center;
`;

export const DataTablesRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: stretch;
  margin: 2rem 1rem 0.5rem;

  .inbox {
    flex: 1 1 320px;
    width: auto;
    margin: 0;
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
  }

  .inbox__body_d_block {
    flex: 1;
  }
`;

export const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 1.4rem;

  th,
  td {
    padding: 0.7rem 0.9rem;
    text-align: left;
    vertical-align: middle;
  }

  th {
    font-weight: 600;
    white-space: nowrap;
    width: 1%;
  }

  td {
    color: #555;
    word-break: break-word;
  }

  tr:not(:last-child) th,
  tr:not(:last-child) td {
    border-bottom: 1px solid #ececec;
  }

  .status-icon-text {
    display: inline-flex;
    margin: 0;
  }
`;
